import React from 'react';
import NewUnitPage from './NewUnitPage';
import { connect } from 'react-redux';
import unitsActions from '../../../../../actions/units.actions';

class NewUnit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      errors: '',
    };
  }

  onCreateUnit = (params) => {
    this.setState(
      { loading: true, errors: '' },
      async () =>
        await this.props
          .createUnit(params)
          .then(() => this.props.history.push('/configure/units'))
          .catch((msg) => this.setState({ loading: false, errors: msg })),
    );
  };
  render() {
    return <NewUnitPage {...this.state} onCreateUnit={this.onCreateUnit} />;
  }
}

export default connect(null, unitsActions)(NewUnit);
